import { apiClient } from './api';

export interface ChatMessage {
  role: 'user' | 'assistant';
  content: string;
  timestamp?: Date;
}

export interface AIMentorConfig {
  chatHistory: ChatMessage[];
  lastUsed?: Date;
}

export interface ChatResponse {
  success: boolean;
  response: string;
}

/**
 * AI Mentor Service
 * Handles all AI Mentor-related API calls
 * Now powered by Azure OpenAI with no API key required from users
 */
export class AIMentorService {
  /**
   * Get AI Mentor chat history
   */
  static async getConfig(): Promise<AIMentorConfig> {
    const response: any = await apiClient.get('/ai-mentor/config');
    return response;
  }

  /**
   * Send chat message to AI Mentor
   */
  static async sendMessage(message: string): Promise<ChatResponse> {
    const response: any = await apiClient.post('/ai-mentor/chat', { message });
    return response;
  }

  /**
   * Clear chat history
   */
  static async clearChatHistory(): Promise<{ success: boolean; message: string }> {
    const response: any = await apiClient.delete('/ai-mentor/chat-history');
    return response;
  }

  /**
   * Delete AI Mentor configuration
   */
  static async deleteConfig(): Promise<{ success: boolean; message: string }> {
    const response: any = await apiClient.delete('/ai-mentor/config');
    return response;
  }
}

export default AIMentorService;
